export const AVATAR_SIZE = 28;
export const AVATAR_RADIUS = "6px";
export const TEXT_INDENT = "38px";
export const FORM_PANEL_DEFAULT_WIDTH = 500;
export const FORM_PANEL_MIN_WIDTH = 380;
export const FORM_PANEL_MAX_WIDTH = 500;
export const FORM_PANEL_STACK_BREAKPOINT = 900;
export const CHAT_MIN_WIDTH = 420;
export const SPLIT_RESIZE_HANDLE_WIDTH = 6;
export const STATUS_WAITING_FOR_REVIEW = "WAITING_FOR_REVIEW";
export const STATUS_WAITING_FOR_HUMAN_INPUT = "WAITING_FOR_HUMAN_INPUT";
export const STATUS_SESSION_UNDER_REVIEW = "SESSION_UNDER_REVIEW";
export const STATUS_HUMAN_TAKEOVER = "HUMAN_TAKEOVER";
export const HUMAN_TAKEOVER_START_TOKEN = "[[HUMAN_TAKEOVER_START]]";
export const HUMAN_TAKEOVER_END_TOKEN = "[[HUMAN_TAKEOVER_END]]";
export const CONTEXT_COMPACTED_TOKEN = "[[CONTEXT_COMPACTED]]";
export const DEFAULT_BLOCKED_WHILE_REVIEW_MESSAGE =
  "This conversation is currently under review. Please wait for the reviewer to finish.";
